import AttendeeAction from './attendeeAction';
import Attendee from '../../../models/attendeeModel';
import Order from '../../../pages/order/models/orderModel';
import { isValidEmail } from '../../order/actions/utils';
import React from 'react';
import { Trans } from 'react-i18next';
import SendReceiptAction from '../../order/actions/sendReceiptAction';

export default class SendTicketAction extends AttendeeAction {
    static NAME = 'send_ticket';
    static ASYNCHRONOUS_LIMIT_MIN = 50;
    static SENDS_EMAILS = true;

    static POST_ACTION_TOAST = response => {
        if (response['initial_count'] === 1) {
            return null;
        }
        return (
            <Trans
                i18nKey="ticket.manager.attendees.action.send_ticket.toast.custom_success_plural"
                values={{ count: response['count'], initial_count: response['initial_count'] }}
            />
        );
    };

    //for send => not deleted and (attendee.email or buyer_email) and not invitation
    static condition(attendee) {
        return (
            ['valid'].includes(attendee.order.status) && !attendee.removed && isValidEmail(attendee.resolved_mail) && !attendee.partner && super.payment_plan_condition(attendee)
        );
    }

    static is_attendee_valid({ attendee, order }) {
        return !attendee.removed && (isValidEmail(attendee.email) || isValidEmail(order.buyer_email));
    }

    static is_available({ feature_flags }) {
        return !feature_flags.includes('EO_APPR');
    }

    run({ attendees = null, orders = null }) {
        if (orders) {
            //for send => not deleted and buyer_email and not invitation
            const to_send = orders.filter(o => SendReceiptAction.condition(o));
            return Order.perform_action(SendReceiptAction.NAME, to_send, { organization: this.organization, event: this.event });
        }

        return Attendee.perform_action(this.constructor.NAME, attendees || this.filtered_items, { organization: this.organization, event: this.event }, this.isAsync(attendees));
    }

    onActionDone() {
        this.onClose();
    }
}
